// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.json-editor-container[data-v-637813a3] {\n    min-height: 150px;\n}\n.json-editor-container[data-v-637813a3] .jsoneditor {\n    min-height: 150px !important;\n}\n", ""]);
// Exports
module.exports = exports;
